import EnteteBonEtFacture from '@/components/en-tete-bon-facture';

export default {
    name: 'print-bon-medical',
    components: {
        EnteteBonEtFacture
    },
    props: {
        prestation: String,
        filename: String,
        selected_bon: Object,
        total_montant_du: Number,
        total_a_payer: Number,
        info_prestation: Object
    },
    data() {
        return {

        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {

    }
}